import { render } from "./ProductsList.vue?vue&type=template&id=320ca323&ts=true"
import script from "./ProductsList.vue?vue&type=script&lang=ts"
export * from "./ProductsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__